"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var ui_1 = require("../../ui");

var FormLayout = function FormLayout(props) {
  var onSubmit = props.onSubmit,
      onCancel = props.onCancel,
      children = props.children,
      cancelLabel = props.cancelLabel,
      submitLabel = props.submitLabel;
  return react_1.default.createElement("form", {
    onSubmit: onSubmit
  }, children, react_1.default.createElement(ui_1.FormButtons, {
    onCancel: onCancel,
    cancelLabel: cancelLabel,
    submitLabel: submitLabel
  }));
};

exports.default = FormLayout;